<template>
  <div class="nps-answer-container">
    <div class="nps-slider width-100">
      <v-slider
        :value="selectedRating"
        min="0"
        max="10"
        step="0"
        :color="colorByRating"
        hide-details
        track-color="#D2D6D9"
        thumb-color="white"
        @change="handleChange"
      ></v-slider>
    </div>

    <div class="nps-legend width-100">
      <div v-for="value in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="value" class="legend-item" :class="getItemColorClass(value)" @click="handleChange(value)">
        <span>{{ value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NpsAnswer',
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedRating: null
    }
  },
  computed: {
    ...mapGetters(['GET_ASSETS']),
    getAssets() {
      return this.GET_ASSETS
    },
    invalidAnswer() {
      return false
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
    colorByRating() {
      if (this.selectedRating <= 6) {
        return '#E03210'
      } else if (this.selectedRating <= 8) {
        return '#F3AF00'
      } else {
        return '#0DA740'
      }
    }
  },
  watch: {
    question: {
      handler(newVal) {
        if (newVal.answers?.[0] === undefined) {
          this.selectedRating = null
        } else {
          this.selectedRating = newVal.answers?.[0]
        }
      },
      deep: true
    }
  },
  methods: {
    handleChange(value) {
      const normalizedValue = Math.round(value)
      this.$emit('change', [normalizedValue])
    },
    getItemColorClass(value) {
      let itemClass = ''
      if (this.selectedRating <= 6) {
        itemClass = 'detractor'
      } else if (this.selectedRating <= 8) {
        itemClass = 'neutral'
      } else {
        itemClass = 'promoter'
      }

      if (this.selectedRating === value) {
        return `${itemClass}-item-selected`
      } else if (this.selectedRating === null || value > this.selectedRating) {
        return 'not-selected-item'
      } else {
        return `${itemClass}-item`
      }
    }
  }
}
</script>

<style scoped lang="scss">
.nps-answer-container {
  margin-top: 26px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 768px) {
    margin-top: 22px;
  }
}

.nps-slider {
  order: 1;

  @media screen and (max-width: 768px) {
    order: 2;
  }
}

.nps-legend {
  display: flex;
  flex-direction: row;
  padding: 12px 8px;
  gap: 28px;
  order: 2;

  @media screen and (max-width: 768px) {
    order: 1;
    padding: 14px 8px;
    gap: 0px;
  }
}

.legend-item {
  width: 40px;
  height: 29px;
  border: 1px solid #c3c8cd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  span {
    font-weight: bold;
    font-size: 14px;
  }

  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }

  @media screen and (max-width: 768px) {
    width: 27px;
    height: 29px;
  }
}

.not-selected-item {
  background-color: white;
  color: #6b7580;
  border: 1px solid #6b7580;
}

.detractor-item {
  background-color: #e0321026;
  color: #b3280d;
  border: 1px solid #e0321026;
}

.detractor-item-selected {
  background-color: #e03210;
  color: white;
}

.neutral-item {
  background-color: #f3af0040;
  color: #d8961c;
  border: 1px solid #f3af0040;
}

.neutral-item-selected {
  background-color: #f3af00;
  color: white;
}

.promoter-item {
  background-color: #0da74026;
  color: #086a29;
  border: 1px solid #0da74026;
}

.promoter-item-selected {
  background-color: #0da740;
  color: white;
}

.gap-32 {
  gap: 32px;
}

.width-100 {
  width: 100%;
}

.nps-slider :deep(.v-slider__container) {
  min-height: 18px !important;
  align-items: center !important;
}

.nps-slider :deep(.v-slider__track-container) {
  height: 12px !important;
  border-radius: 6px !important;
  overflow: hidden;
}

.nps-slider :deep(.v-slider__track) {
  height: 12px !important;
  border-radius: 6px !important;
}

.nps-slider :deep(.v-slider__track-fill) {
  transition: background-color 0.22s ease, border-color 0.22s ease !important;
}

.nps-slider :deep(.v-slider__thumb-container) {
  height: 18px !important;
  width: 18px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}

.nps-slider :deep(.v-slider__thumb) {
  height: 18px !important;
  width: 18px !important;
  background: #fff !important;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-shadow: 0px 2px 4px 0px #00000029;
}
</style>
